module.exports = __webpack_public_path__ + "static/media/ic_unorderedlist.cae7d96a.svg";